import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseModel } from '../shared/models/response.model';

export const erroHandler = <T>(e: HttpErrorResponse, obj?: Observable<T>): Observable<T> => {
  const discard = [500, 504, 404];
  if (discard.indexOf(e.status) < 0) {
    if (e.status === 401 || e.status === 403) {
      if (e.error?.messages) {
        return of(e.error);
      }
      const naoAutorizado: ResponseModel<any> | any = {
        success: false,
        messages: [
          e.status === 401
            ? 'Usuário não autenticado. Efetue login novamente.'
            : 'Usuário não tem acesso a essa funcionalidade.'
        ],
        data: null
      };
      return of(naoAutorizado);
    }

    return of(e.error);
  }

  if (e.error?.messages) {
    if (!environment.production && e.error?.errors) {
      e.error.messages = [...e.error.messages, ...e.error.errors];
    }
    return of(e.error);
  }

  // provavelmente um erro no front
  const msg = 'Ocorreu um erro na aplicação';
  const resp: ResponseModel<any> | any = {
    success: false,
    messages: environment.production ? [msg] : [e.error, e.message, msg],
    data: null
  };
  return of(resp);
};
